import Api from 'src/services/ApiService';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CommonAxiosResponse } from 'src/types';
import {
  CreateEventSubscriptionRequest,
  CreateEventSubscriptionResponse,
  GetEventsSubscriptionListResponse,
  GetEventsSubscriptionsListRequest,
  GetEventSubscriptionDetailsResponse,
  UpdateEventSubscriptionRequest,
  UpdateEventSubscriptionResponse
} from './types';

export const getEventSubscriptionsListThunk = createAsyncThunk<
  CommonAxiosResponse<GetEventsSubscriptionListResponse>,
  GetEventsSubscriptionsListRequest
>('event-subscriptions/getEventSubscriptionsListThunk', async (data) => {
  const response = await Api.get(`/ecomm/internal/event/list/get`, data);
  return response;
});

export const createEventSubscriptionsThunk = createAsyncThunk<
  CommonAxiosResponse<CreateEventSubscriptionResponse>,
  CreateEventSubscriptionRequest
>('event-subscriptions/createEventSubscriptionsThunk', async (data) => {
  const response = await Api.post(`/ecomm/internal/event/create`, data);
  return response;
});

export const getEventSubscriptionDetailsThunk = createAsyncThunk<
  CommonAxiosResponse<GetEventSubscriptionDetailsResponse>,
  number
>('event-subscriptions/getEventSubscriptionDetailsThunk', async (id) => {
  const response = await Api.get(`/ecomm/internal/event/details/get/${id}`);
  return response;
});

export const updateEventSubscriptionDetailsThunk = createAsyncThunk<
  CommonAxiosResponse<UpdateEventSubscriptionResponse>,
  UpdateEventSubscriptionRequest
>('event-subscriptions/getEventSubscriptionDetailsThunk', async (data) => {
  const response = await Api.patch(
    `/ecomm/internal/event/update/${data?.id}`,
    data
  );
  return response;
});

// export const deleteEventSubscriptionDetailsThunk = createAsyncThunk<
//   CommonAxiosResponse<CreateEventSubscriptionResponse>,
//   number
// >('event-subscriptions/getEventSubscriptionDetailsThunk', async (id) => {
//   const response = await Api.get(`/event_subscription/details/get/${id}`);
//   return response;
// });
